import IconZoomIn from '@picsart/icons/IconZoomIn';

import useStyles from './styles';

interface IProps {
  onClick: () => void;
  icon: React.ElementType;
  dataTestid: string;
}

interface IToggler {
  onClick: () => void;
}

const ZoomInOutButton = ({
  onClick, icon: Icon, dataTestid,
}: IProps) => {
  const classes = useStyles();

  return (
    <button className={classes.root} onClick={onClick} data-testid={dataTestid}>
      <Icon className={classes.icon} data-testid="zoom-button" />
    </button>
  );
};

export const Toggler = ({ onClick }: IToggler) => {
  const classes = useStyles();
  return (
    <button className={classes.root} onClick={onClick}>
      <IconZoomIn className={classes.icon} />
    </button>
  );
};

export default ZoomInOutButton;
